module.exports = __webpack_public_path__ + "assets/img/Hero_Bg.a008f01d.svg";